import { Component, OnInit } from '@angular/core';
import { Grid } from '../../../core/components/grid/grid.model';
import { GridOptions, GridRow } from '../../../core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';

@Component({
    selector: 'tt-charges',
    templateUrl: './charges.component.html',
    styleUrls: ['./charges.component.css'],
})
export class ChargesComponent implements OnInit {
    public grid?: GridOptions;

    public gridChargeTest?: GridOptions;

    constructor(private modal: ModalService) {}

    private loadGrid() {
        if (!this.grid) {
            this.grid = new Grid()
                .setRememberId('charge_grid')
                .setLoadDataFunction({
                    method: 3917,
                    parameters: {},
                })
                // .setKendoConfig({ height: '50%' })
                .setToolbar({ wrapping: true })
                .setCustomToolbarButtons([
                    {
                        name: 'new_charge',
                        text: 'new_charge',
                        translate: true,
                        icon: 'far fa-plus',
                        cssClass: 'im-grid-btn-xs-l tt-button tt-button--primary',
                        func: async () => {
                            const response = await this.modal.openStateDialog({ state: 'charge', params: '0' });

                            if (!!response) {
                                this.grid?.gridfunc?.read();
                            }
                        },
                    },
                ])
                .setSpecialFunc({
                    buttons: [
                        {
                            name: 'open_charge',
                            icon: 'fas fa-pen',
                            btn_type: 'primary',
                            tooltip: 'open_charge',
                            translateTooltip: true,
                            func: async (row: GridRow) => {
                                const response = await this.modal.openStateDialog({ state: 'charge', params: '' + row['charge_keyno'] });

                                if (!!response) {
                                    this.grid?.gridfunc?.read();
                                }
                            },
                        },
                    ],
                })
                .setOptionFunc((data: any) => this.optionFuncChargeTest(data.data));
        } else {
            this.grid?.gridfunc?.read();
        }
    }

    private optionFuncChargeTest(data: any) {
        if (!!data?.clickedCell?.dataItem) {
            //console.log('data: ');
            //console.dir(data.clickedCell.dataItem);

            this.gridChargeTest = new Grid()
                .setRememberId('chargetest_grid')
                .setLoadDataFunction({
                    method: 3918,
                    parameters: data?.clickedCell?.dataItem,
                })
                .setKendoConfig({ height: '50%' })
                .setToolbar({ wrapping: true });

            //this.gridChargeTest?.gridfunc?.read();
        }
    }

    private async init() {
        this.loadGrid();
    }

    ngOnInit() {
        this.init();
    }
}
